import { Dropdown as _Dropdown, DropdownProps as _DropdownProps } from 'antd'

import { ReactNode, UIEventHandler, useEffect, useState } from 'react'

import './Dropdown.css'

export type DropdownProps = _DropdownProps
interface Props extends DropdownProps {
  children: ReactNode
  onScrollEnd?: () => Promise<void>
}

const Dropdown = ({
  children,
  overlayClassName,
  menu,
  onScrollEnd,
  ...props
}: Props) => {
  const [isScrollEnd, setIsScrollEnd] = useState<boolean>(false)

  const handlePopupScroll: UIEventHandler<HTMLUListElement> = (e) => {
    if (!onScrollEnd) return
    const { target } = e
    if (
      !isScrollEnd &&
      (target as any).scrollTop + (target as any).offsetHeight >
        (target as any).scrollHeight - 100
    ) {
      setIsScrollEnd(true)
    }
  }

  useEffect(() => {
    if (isScrollEnd && onScrollEnd) {
      const handleOnScrollEnd = async () => {
        await onScrollEnd()
        setIsScrollEnd(false)
      }

      handleOnScrollEnd()
    }
  }, [isScrollEnd])

  return (
    <_Dropdown
      overlayClassName={`customDropdown ${overlayClassName}`}
      menu={{ ...menu, onScroll: handlePopupScroll }}
      {...props}
    >
      {children}
    </_Dropdown>
  )
}

export default Dropdown
